import type { Components } from '@mui/material/styles';

export default function MUISpeedDial(): Components['MuiSpeedDial'] {
  return {};
}
